<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 起保日期 -->
            <el-table-column align="left" label="起保日期" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.effective_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 船名 -->
            <el-table-column align="left" label="船名" width="200px">
            <template slot-scope="scope">
                <span >{{ scope.row.ship_name }}</span>
            </template>
            </el-table-column>                                

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" width="250px">
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span  class="text-link">{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种">
            <template slot-scope="scope">
                <span >{{ scope.row.insurance_type }}</span>
            </template>
            </el-table-column>   

            <!-- 实收保费 -->
            <el-table-column align="left" label="实收保费" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency}}</span>
            </template>
            </el-table-column>

            <!-- 费用比例(%) -->
            <el-table-column align="left" label="费用比例(%)" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate }}%</span>
            </template>
            </el-table-column>

            <!-- 手续费金额 -->
            <el-table-column align="left" label="手续费金额" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency}}</span>
            </template>
            </el-table-column>       
        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-dong-hai-guang-dong',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },        
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>